var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { InvoiceKind } from '../enums/invoice-kind.enum.js';
import { PatientInvoiceSettlement } from '../enums/patient-invoice-settlement.enum.js';
import { PatientInvoiceStatus } from '../enums/patient-invoice-status.enum.js';
import { PaymentMethod } from '../enums/payment-method.enum.js';
export class PatientInvoiceLineResponseDto {
    id;
    lineOrder;
    /** `null` for `CANCELLATION_FEE` invoice lines (no `TreatmentUnit`). */
    treatmentUnitId;
    treatmentPlanId;
    /** `null` for `CANCELLATION_FEE` invoice lines (no `BillableServiceItem`). */
    billableServiceItemId;
    /** `null` for `CANCELLATION_FEE` invoice lines (no Heilmittel-Positions-Nr). */
    posNumber;
    displayName;
    netPrice;
    taxRate;
    taxType;
    currency;
    deliveryDate;
    prescriptionReference;
    grossPrice;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceLineResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceLineResponseDto.prototype, "lineOrder", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceLineResponseDto.prototype, "treatmentUnitId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceLineResponseDto.prototype, "treatmentPlanId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceLineResponseDto.prototype, "billableServiceItemId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceLineResponseDto.prototype, "posNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceLineResponseDto.prototype, "displayName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceLineResponseDto.prototype, "netPrice", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceLineResponseDto.prototype, "taxRate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceLineResponseDto.prototype, "taxType", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceLineResponseDto.prototype, "currency", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], PatientInvoiceLineResponseDto.prototype, "deliveryDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceLineResponseDto.prototype, "prescriptionReference", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceLineResponseDto.prototype, "grossPrice", void 0);
/** Shared by Zahlung and Ausbuchung: who reversed it, on which Berlin day, and why. */
export class PatientInvoiceReversalResponseDto {
    reversedOn;
    reversedAt;
    reversedBy;
    reason;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceReversalResponseDto.prototype, "reversedOn", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], PatientInvoiceReversalResponseDto.prototype, "reversedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceReversalResponseDto.prototype, "reversedBy", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceReversalResponseDto.prototype, "reason", void 0);
export class PatientInvoicePaymentResponseDto {
    id;
    amountCents;
    /** Berlin calendar day, `YYYY-MM-DD`. */
    paymentDate;
    method;
    reference;
    recordedAt;
    recordedBy;
    /** Set once the Zahlung was storniert; a reversed Zahlung counts as never made. */
    reversal;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoicePaymentResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoicePaymentResponseDto.prototype, "amountCents", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoicePaymentResponseDto.prototype, "paymentDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoicePaymentResponseDto.prototype, "method", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoicePaymentResponseDto.prototype, "reference", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], PatientInvoicePaymentResponseDto.prototype, "recordedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoicePaymentResponseDto.prototype, "recordedBy", void 0);
__decorate([
    Expose(),
    Type(() => PatientInvoiceReversalResponseDto),
    __metadata("design:type", Object)
], PatientInvoicePaymentResponseDto.prototype, "reversal", void 0);
export class PatientInvoiceWriteOffResponseDto {
    id;
    amountCents;
    /** Berlin calendar day, `YYYY-MM-DD`. */
    writeOffDate;
    reason;
    recordedAt;
    recordedBy;
    reversal;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceWriteOffResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceWriteOffResponseDto.prototype, "amountCents", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceWriteOffResponseDto.prototype, "writeOffDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceWriteOffResponseDto.prototype, "reason", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], PatientInvoiceWriteOffResponseDto.prototype, "recordedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceWriteOffResponseDto.prototype, "recordedBy", void 0);
__decorate([
    Expose(),
    Type(() => PatientInvoiceReversalResponseDto),
    __metadata("design:type", Object)
], PatientInvoiceWriteOffResponseDto.prototype, "reversal", void 0);
export class PatientInvoiceResponseDto {
    id;
    createdAt;
    updatedAt;
    patientId;
    officeLocationId;
    /** Lifecycle only (ADR-0043): DRAFT, ISSUED or CANCELLED. */
    status;
    /** Zahlungsstand, derived from `payments` and `writeOffs`. */
    settlement;
    /** Offener Betrag in cents: total minus active Zahlungen minus an active Ausbuchung. */
    openAmountCents;
    /**
     * Berlin day of the Zahlung that brought the Offener Betrag to zero. Null
     * unless the invoice is Bezahlt.
     */
    paidOn;
    /** Every Zahlung, reversed ones included, oldest first. */
    payments;
    /** Every Ausbuchung, reversed ones included, oldest first. At most one is active. */
    writeOffs;
    /**
     * Shared identity vocabulary — kind + number (+ dunningStage / refInvoiceNumber
     * for credit notes / dunning letters). Consumed by the frontend's identity
     * formatters and by the PDF template renderer.
     */
    identity;
    /** ID of the rendered invoice PDF in the BillingDocument store. Null while DRAFT. */
    documentId;
    /** ID of the credit-note PDF in the BillingDocument store. Set when the invoice is CANCELLED. */
    creditNoteDocumentId;
    /**
     * Identity of the credit-note (Stornorechnung). Set together with
     * `creditNoteDocumentId` when the invoice is CANCELLED. Used by the
     * frontend to compose the storno download filename.
     */
    creditNoteIdentity;
    issuedAt;
    dueDate;
    /** Versendet: the delivery fact, independent of lifecycle and Zahlungsstand. */
    sentAt;
    totalNet;
    totalGross;
    totalTax;
    currency;
    /**
     * Payer domain code snapshotted from the originating treatment plan at draft
     * creation (and re-snapshotted at issue). `pkv | self_pay` for current scope;
     * `null` for legacy drafts created before this field was wired.
     */
    payerDomainCode;
    /**
     * TM-9064 slice 4 — invoice kind discriminator. `THERAPY` = the regular
     * spine invoice; `CANCELLATION_FEE` = standalone Schadensersatz invoice.
     */
    kind;
    lines;
    /**
     * Inline reason why this ISSUED invoice rests undelivered. `null` once
     * `sentAt` is set or the invoice is not ISSUED, and for invoices that are
     * deliverable (transient, e.g. between enqueue and stamping `sentAt`).
     */
    deliveryRestReason;
    /**
     * Mahnsperre (per-invoice dunning block, PRD #988). `dunningBlockReason`
     * non-null ⇒ a block exists; `dunningBlockedUntil` null ⇒ until lifted, a
     * date ⇒ temporary auto-expiring block. `dunningBlockedBy`/`dunningBlockedAt`
     * are audit fields. The frontend derives "currently active" the same way the
     * aggregate does (reason set AND not past `until`).
     */
    dunningBlockReason;
    dunningBlockedUntil;
    dunningBlockedBy;
    dunningBlockedAt;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], PatientInvoiceResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], PatientInvoiceResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceResponseDto.prototype, "patientId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceResponseDto.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceResponseDto.prototype, "settlement", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceResponseDto.prototype, "openAmountCents", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "paidOn", void 0);
__decorate([
    Expose(),
    Type(() => PatientInvoicePaymentResponseDto),
    __metadata("design:type", Array)
], PatientInvoiceResponseDto.prototype, "payments", void 0);
__decorate([
    Expose(),
    Type(() => PatientInvoiceWriteOffResponseDto),
    __metadata("design:type", Array)
], PatientInvoiceResponseDto.prototype, "writeOffs", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "identity", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "documentId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "creditNoteDocumentId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "creditNoteIdentity", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "issuedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "dueDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "sentAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceResponseDto.prototype, "totalNet", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceResponseDto.prototype, "totalGross", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PatientInvoiceResponseDto.prototype, "totalTax", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceResponseDto.prototype, "currency", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "payerDomainCode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], PatientInvoiceResponseDto.prototype, "kind", void 0);
__decorate([
    Expose(),
    Type(() => PatientInvoiceLineResponseDto),
    __metadata("design:type", Array)
], PatientInvoiceResponseDto.prototype, "lines", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "deliveryRestReason", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "dunningBlockReason", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "dunningBlockedUntil", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "dunningBlockedBy", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PatientInvoiceResponseDto.prototype, "dunningBlockedAt", void 0);
//# sourceMappingURL=patient-invoice.response.dto.js.map